import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SignupForm from '../SignupForm';
import events from '../SignupPageContainer/events';
import { AdjustTrackEvent } from '../../modules/analytics/adjust';
import { trackEvent } from '../../modules/analytics';
import {
  Wrapper,
  OverlayWrapper,
  Overlay,
  OverlayHeaderSection,
  OverlayContent,
  SwitchToAnchor,
} from '../ImportOnboarding/styles';
import { ValuePropositions } from './components/ValuePropositions';
import { OverlayOverrideCSS, Header1, Paragraph } from '../LoginPage/styles';
import { Header2, SwitchToAnchorOverrideCSS } from './styles';

export function SignupPage({
  error,
  routing,
  onSubmit,
  anyTouched,
  submitting,
  onClickRequestResetPassword,
}) {
  useEffect(() => {
    // Required for Floodlight tagging
    gtag('event', 'conversion', {
      allow_custom_scripts: true,
      send_to: 'DC-9266237/ancho0/spoti00+standard',
    });

    // adjust log for viewing sign up
    trackEvent(
      null,
      { eventToken: AdjustTrackEvent.ONBOARDING_STARTED },
      { providers: [Adjust] }
    );
  }, []);

  return (
    <Wrapper>
      <SwitchToAnchor className={SwitchToAnchorOverrideCSS}>
        <Header2>Welcome to Anchor</Header2>
        <ValuePropositions />
      </SwitchToAnchor>
      <OverlayWrapper>
        <Overlay className={OverlayOverrideCSS}>
          <OverlayHeaderSection>
            <Header1>Create your account</Header1>
            <Paragraph>
              Already have an account?{' '}
              <Link
                data-cy="loginLink"
                to="/login"
                onClick={events.signUpSignInButtonClicked}
              >
                Log in
              </Link>{' '}
              instead.
            </Paragraph>
          </OverlayHeaderSection>
          <OverlayContent>
            <SignupForm
              anyTouched={anyTouched}
              error={error}
              onSubmit={onSubmit}
              routing={routing}
              submitting={submitting}
              location={routing.location}
              onClickRequestResetPassword={onClickRequestResetPassword}
            />
          </OverlayContent>
        </Overlay>
      </OverlayWrapper>
    </Wrapper>
  );
}
